import { VENDOR_LOCALES } from 'src/constants/locales';

const supportedLocales = VENDOR_LOCALES.map(({ id }) => id);

export const closestSupportedLocale = (language: string): string | null => {
    const normalized = language.toLowerCase().replaceAll('_', '-');
    const exact = supportedLocales.find((locale) => locale.toLowerCase() === normalized);
    if (exact) return exact;
    const base = normalized.split('-')[0];
    return supportedLocales.find((locale) => locale.toLowerCase().split('-')[0] === base) ?? null;
};

export const resolveReaderLocale = (
    browserLocaleOverride: string | null | undefined,
    browserLanguages: readonly string[],
): string => {
    if (browserLocaleOverride) {
        return closestSupportedLocale(browserLocaleOverride) ?? 'en-CA';
    }
    for (const language of browserLanguages) {
        const locale = closestSupportedLocale(language);
        if (locale) return locale;
    }
    return 'en-CA';
};

export const readerTranslationLanguage = (locale: string): string => locale.toLowerCase();
